'use strict';

var mcb = mcb || {};

mcb.screendarken = mcb.screendarken || new function () {

    this.init = function () {

        // Get wrapper element
        const filterWrapper = document.querySelector('.generic-list .filters__wrapper');
        
        // Get the filter section
        const filters = document.querySelector('.generic-list .filters');
        
        // Get all dropdown toggle elements inside the filter section
        const ddFilterToggles = filters?.querySelectorAll('.dropdown-toggle');

        let overlay, activeToggle, isFilterWrapperShown = false;
      
        // If there are no dropdown-toggle elements, return
        if (!ddFilterToggles) return;
      
        // Add event listeners to each dropdown toggle element
        ddFilterToggles.forEach(ddToggle => {
        
          // When the dropdown toggle is shown
          ddToggle.addEventListener('show.bs.dropdown', () => {
            
            // If there is an active toggle and it is not the same as the current toggle
            if (activeToggle && activeToggle !== ddToggle) {
              // Remove the screen darken overlay and reset the filter wrapper class
              filters.removeChild(filters.querySelector('.screen-darken'));
              overlay = null;
            }
            activeToggle = ddToggle;
            
           
            // If the overlay does not exist, create it and append it to filters
            if (!overlay) {
              overlay = document.createElement('div');
              overlay.className = 'screen-darken show fade';
              filters.appendChild(overlay);
              isFilterWrapperShown = true;
            }
            
            // If the filter wrapper is not shown, show it
            if (!isFilterWrapperShown) {
              filterWrapper.classList.add('show');
              isFilterWrapperShown = true;
            } 
            // Otherwise, add the 'show' class to the filter wrapper
            else {
              filterWrapper.classList.add('show');
            }
          });
      
          // When the dropdown toggle is hidden
          ddToggle.addEventListener('hide.bs.dropdown', () => {
            if (activeToggle === ddToggle) {
              activeToggle = null;
              // If the overlay exists, remove it
              if (overlay) {
                filters.removeChild(overlay);
                overlay = null;
              }
              // Reset the filter wrapper class and isFilterWrapperShown variable
              filterWrapper.classList.remove('show');
              isFilterWrapperShown = false;
            }
          });
        });
      };
}();